import { createContext, useContext, useState } from "react";

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "th");

  const toggle = () => {
    setLang(prev => {
      const next = prev === "th" ? "en" : "th";
      localStorage.setItem("lang", next);
      return next;
    });
  };

  // ตั้งภาษาตรงๆ (ใช้กับ dropdown เลือกภาษา)
  const setLanguage = (code) => {
    if (code !== "th" && code !== "en") return;
    localStorage.setItem("lang", code);
    setLang(code);
  };

  return (
    <LanguageContext.Provider value={{ lang, toggle, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
